import {
    BATTERIES_UPDATE
} from '../../actions/action-types';
import appInitialState from '../../store/appInitialState';

const initialState = appInitialState.batteries;

/**
 * This is the application state's batteries slice reducer
 *
 * @param {Object} state 
 * @param {Object} action
 */
function batteriesReducer(state = initialState, action) {

    switch(true) {

        case (action.type === BATTERIES_UPDATE):

            state = action.payload.batteries;
            break;

        default:

    }

    return state;
};

export default batteriesReducer;